import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  // Initialize to 23h 59m 59s, persist in sessionStorage so it doesn't reset on re-renders
  const getInitialTime = () => {
    if (typeof window === 'undefined') return 23 * 3600 + 59 * 60 + 59;
    const stored = sessionStorage.getItem('dp_countdown_end');
    if (stored) {
      const endTime = parseInt(stored, 10);
      const remaining = Math.floor((endTime - Date.now()) / 1000);
      if (remaining > 0) return remaining;
    }
    const totalSeconds = 23 * 3600 + 59 * 60 + 59;
    sessionStorage.setItem('dp_countdown_end', String(Date.now() + totalSeconds * 1000));
    return totalSeconds;
  };
  const [timeLeft, setTimeLeft] = useState(getInitialTime);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          // Reset for continuous urgency
          const fresh = 23 * 3600 + 59 * 60 + 59;
          sessionStorage.setItem('dp_countdown_end', String(Date.now() + fresh * 1000));
          return fresh;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  const Unit = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-133">
      <div className="bg-black text-white font-black text-2xl md:text-4xl rounded-lg md:rounded-xl px-3 md:px-5 py-2 md:py-3 min-w-[3rem] md:min-w-[4.5rem] text-center tabular-nums shadow-md" data-id="element-134">
        {pad(value)}
      </div>
      <span className="text-[10px] md:text-xs font-bold text-gray-600 uppercase tracking-wider mt-1.5" data-id="element-135">
        {label}
      </span>
    </div>;
  return <div className="bg-red-50 border-2 border-red-200 rounded-2xl p-4 md:p-6 max-w-2xl mx-auto" data-id="element-136">
      <div className="flex items-center justify-center gap-2 mb-3" data-id="element-137">
        <Clock className="w-5 h-5 md:w-6 md:h-6 text-red-500 animate-pulse" data-id="element-138" />
        <p className="text-sm md:text-base font-black text-red-500 uppercase tracking-wider" data-id="element-139">
          ¡La oferta termina en!
        </p>
      </div>
      <div className="flex items-start justify-center gap-2 md:gap-3" data-id="element-140">
        <Unit value={hours} label="Horas" data-id="element-141" />
        <span className="text-2xl md:text-4xl font-black text-black mt-2 md:mt-3" data-id="element-142">
          :
        </span>
        <Unit value={minutes} label="Minutos" data-id="element-143" />
        <span className="text-2xl md:text-4xl font-black text-black mt-2 md:mt-3" data-id="element-144">
          :
        </span>
        <Unit value={seconds} label="Segundos" data-id="element-145" />
      </div>
    </div>;
}